export default "__VITE_ASSET__b76cc2c0__"